import { getRelatedPropertiesElementsAction } from 'redux/actions/propertiesActions';
import { generateRequestWithDataReducer } from 'redux/utils/requestWithData';

export default generateRequestWithDataReducer(getRelatedPropertiesElementsAction);
